const jwtDecode = require('jwt-decode');
const Session = require('./session');
const moment = require('moment');

var apiBaseUrl = getApiBaseUrl();
var accessToken = Session.getSessionAccessToken();
var refreshToken = Session.getSessionRefreshToken();
var jivoToken = Session.getSessionJivoToken();

function getFullUrl(methodUrl) {
    return apiBaseUrl + methodUrl;
}

function getFetchConfig(method, data, signal) {
    var body = null;
    var headers = {};

    if (data instanceof FormData) {
        body = data;
    } else {
        if (data) {
            body = JSON.stringify(data);
        }
        headers['Content-Type'] = 'application/json; charset=utf-8';
    }

    if (accessToken) {
        headers['Authorization'] = 'Bearer ' + accessToken;
    }

    return {
        signal,
        body: body,
        method: method,
        headers: headers,
        mode: 'cors'
    };
}

function apiGetInner(methodUrl) {
    return fetch(getFullUrl(methodUrl), getFetchConfig('GET'))
        .then(catch401)
        .then(resolveJson);
}

function apiPostInner(methodUrl, data = {}, signal) {
    return fetch(getFullUrl(methodUrl), getFetchConfig('POST', data, signal))
        .then(catch401)
        .then(resolveJson);
}

function apiDownloadInner(methodUrl, data = {}) {
    return fetch(getFullUrl(methodUrl), getFetchConfig('POST', data))
        .then(catch401)
        .then(d => {
                return d.blob().then(res => (
                    {
                        data: res,
                        headers: {"content-disposition": d.headers.get('Content-Disposition')}
                    }
                ))
            }
        );
}

function apiPutInner(methodUrl, data = {}) {
    return fetch(getFullUrl(methodUrl), getFetchConfig('PUT', data))
        .then(catch401)
        .then(resolveJson);
}

function isValidToken(token) {
    if (token) {
        let tokenData = jwtDecode(token);
        let expiresAt = moment.utc(tokenData.ExpiresUtc);
        return moment.utc().isBefore(expiresAt);
    } else {
        return false;
    }
}

var refreshRequests = [];

function ensureTokens() {
    if (isValidToken(accessToken)) {
        return Promise.resolve(true);
    } else if (refreshRequests.length > 0) {
        let promise = new Promise((resolve, reject) => {
            refreshRequests.push(resolve);
        });
        return promise;
    } else if (isValidToken(refreshToken)) {
        let promise = new Promise((resolve, reject) => {
            refreshRequests.push(resolve);
        });
        apiPostInner("auth/refresh", {refreshToken: refreshToken})
            .then(response => {
                startApiSession(response.accessToken, response.refreshToken, false, response.jivoToken);
                refreshRequests.forEach((resolve, ind, arr) => {
                    resolve(true);
                });
                refreshRequests = [];
            });
        return promise;
    } else if (Session.isAnonymousAllowed()) {
        return Promise.resolve(true);
    } else {
        stopApiSession();
        return Promise.reject("");
    }
}

function catch401(response) {
    if (response.status === 401) {
        stopApiSession();
        return Promise.reject("Unauthorized");
    }
    if (response.status > 401) {
        return Promise.reject(response);
    }
    return Promise.resolve(response);
}

function convertJson(text) {
    try {
        return JSON.parse(text);
    } catch (err) {
        return text;
    }
}

function resolveJson(response) {
    return response.text()
        .then(text => {
            let result = convertJson(text);
            if (!response.ok) {
                return Promise.reject(result);
            }
            return result;
        });
}

function validateToken() {
    return ensureTokens()
        .then(() => {
            if (accessToken) {
                return apiGetInner('auth/check')
                    .then(() => {
                        return Promise.resolve(true);
                    });
            } else if (Session.isAnonymousAllowed()) {
                return Promise.resolve(true);
            } else {
                stopApiSession();
                return Promise.reject("");
            }
        });
}

function startApiSession(newAccessToken, newRefreshToken, needRedirect, newJivoToken) {
    accessToken = newAccessToken;
    refreshToken = newRefreshToken;
    jivoToken = newJivoToken;
    Session.restoreSession(newAccessToken, newRefreshToken, needRedirect, newJivoToken);
}

function stopApiSession() {
    accessToken = null;
    refreshToken = null;
    jivoToken = null;
    Session.stopSession();
}

function apiGet(methodUrl) {
    return ensureTokens().then(() => apiGetInner(methodUrl));
}

function apiPost(methodUrl, data = {}, signal) {
    return ensureTokens().then(() => apiPostInner(methodUrl, data, signal));
}

function apiDownload(methodUrl, data = {}) {
    return ensureTokens().then(() => apiDownloadInner(methodUrl, data));
}

function apiPut(methodUrl, data = {}) {
    return ensureTokens().then(() => apiPutInner(methodUrl, data));
}

module.exports = {
    validateToken: validateToken,
    startApiSession: startApiSession,
    stopApiSession: stopApiSession,
    apiGet: apiGet,
    apiPost: apiPost,
    apiPut: apiPut,
    apiDownload
};


// WEBPACK FOOTER //
// ./App/services/apiClient.js